// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Banner-module--bx--text-truncate--end--2XZxG";
export var bxTextTruncateFront = "Banner-module--bx--text-truncate--front--WlJUb";
export var column = "Banner-module--column--1FbX7";
export var grid = "Banner-module--grid--3MX1x";
export var row = "Banner-module--row--2lOWC";